import { AppFooterController as controller } from './appFooter.controller';
import template from './appFooter.html';

export default {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm',
};



// WEBPACK FOOTER //
// ./src/app/common/ui/appFooter/appFooter.component.js